/**
 * Flechas para los carretes de escritorio — WEB RONDA 2 §3.
 *
 * En móvil la fila se arrastra con el pulgar y no hace falta nada. En
 * escritorio no hay gesto de arrastre evidente, así que una fila que se
 * desplaza sin flechas es contenido que nadie descubre: por eso la primera
 * versión la convertía en retícula. Creativa pide el carrete en las dos, así
 * que el carrete vuelve y las flechas son la condición para que funcione.
 *
 * El elemento no sabe nada de productos ni de reseñas: sólo de una tira que
 * desborda. Lo usan el riel de producto, las reseñas y los videos.
 *
 * Sin JS la tira sigue siendo un scroller nativo: se desplaza con rueda,
 * teclado y barra. Las flechas son una ayuda, no el único camino.
 */
class NnhCarrete extends HTMLElement {
  connectedCallback() {
    this.tira = this.querySelector('[data-carrete-tira]');
    if (!this.tira) return;

    this.botones = [...this.querySelectorAll('[data-carrete]')];
    for (const b of this.botones) {
      b.addEventListener('click', () => this.mueve(Number(b.dataset.carrete)));
    }

    /* `scroll` se dispara en cada cuadro del desplazamiento suave; el estado de
     * las flechas sólo tiene que llegar al final, así que se agrupa en un
     * cuadro de animación. */
    let pendiente = false;
    const alDesplazar = () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => {
        pendiente = false;
        this.pinta();
      });
    };
    this.tira.addEventListener('scroll', alDesplazar, { passive: true });

    /* El ancho de la tira cambia con la ventana y también cuando las tarjetas
     * terminan de cargar sus fotos. ResizeObserver cubre los dos casos. */
    this.observador = new ResizeObserver(() => this.pinta());
    this.observador.observe(this.tira);

    this.pinta();
  }

  disconnectedCallback() {
    this.observador?.disconnect();
  }

  /**
   * Un salto es una pantalla menos una tarjeta: así la última que se vio queda
   * a la vista como ancla y no se pierde el hilo de la fila.
   */
  mueve(signo) {
    const item = this.tira.firstElementChild;
    const ancho = item ? item.getBoundingClientRect().width : 240;
    const salto = Math.max(ancho, this.tira.clientWidth - ancho);
    this.tira.scrollBy({ left: signo * salto, behavior: 'smooth' });
  }

  /** Flechas fuera si no hay desborde, y apagadas en cada extremo. */
  pinta() {
    const sobra = this.tira.scrollWidth - this.tira.clientWidth;
    this.classList.toggle('carrete--quieto', sobra < 4);
    const x = this.tira.scrollLeft;
    for (const b of this.botones) {
      const haciaAtras = Number(b.dataset.carrete) < 0;
      b.disabled = haciaAtras ? x < 4 : x > sobra - 4;
    }
  }
}

if (!customElements.get('nnh-carrete')) customElements.define('nnh-carrete', NnhCarrete);
